export default __webpack_public_path__ + "static/media/slide-7.55dabc8d.webp";